<template>
<div v-if="hasAdminAccess && (user != null || currentuser != null)">
    <v-card>
        <v-card-title v-show="!isLoggedInUserActive">
            <label style="color: red">{{ $t("msguserisnotactive") }}</label>
        </v-card-title>
        <v-card-title v-show="isLoggedInUserActive">
            {{ $t("companies") }}
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" v-bind:label="$t('searchall')" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="companies" :search="search" v-show="isLoggedInUserActive" :footer-props="{
                itemsPerPageOptions:tableItemsPerPage
            }">
            <template v-slot:[`header.plant`]="{}">
                {{ $t("plant") }}
            </template>
            <template v-slot:[`header.value`]="{}">
                {{ $t("company") }}
            </template>
            <template v-slot:[`header.otherInfo`]="{}">
                {{ $t("otherinfo") }}
            </template>
            <template v-slot:[`header.updatedBy`]="{}">
                {{ $t("updatedby") }}
            </template>
            <template v-slot:[`header.updatedOn`]="{}">
                {{ $t("updatedon") }}
            </template>
            <template v-slot:[`header.action`]="{}">
                {{ $t("actions") }}
            </template>
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-dialog v-model="dialog" max-width="500px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">{{ $t("new") }}</v-btn>
                        </template>
                        <!-- Display status / error messages coming from api -->
                        <div id="error" v-show="dialog && statusmessages.length > 0">
                            <v-alert :value="true" type="error">
                                <div>
                                    <ul>
                                        <li v-for="(status, index) in statusmessages" :key="index">
                                            {{ status.message }}
                                        </li>
                                    </ul>
                                </div>
                            </v-alert>
                        </div>
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                                <v-spacer></v-spacer>
                                <v-icon @click="close">close</v-icon>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="8" md="6">
                                            <v-select style="background-color: #ffffcc" :items="plants" v-bind:label="$t('plant')" v-model="selecttedplant" item-text="plant" item-value="id" :readonly="readonlyPlant" @change="changePlant">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" sm="8" md="8">
                                            <v-text-field v-model="editedItem.value" v-bind:label="$t('company')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4" md="4" style="padding-top: 30px">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon v-bind="attrs" v-on="on" class="ma-2" color="red" dark>mdi-help</v-icon>
                                                </template>
                                                <span>{{ $t("tooltipcompany") }}</span>
                                            </v-tooltip>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-text-field v-model="editedItem.otherInfo" v-bind:label="$t('otherinfo')"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn color="blue darken-1" text @click="close">
                                    {{ $t("cancel") }}</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" dark class="mb-2" @click="save">{{
                    $t("save")
                  }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <!-- <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
         <v-btn
            color="blue-grey"
            class="white--text"
            @click="exportexcel"
            >
            Export to Excel
        <v-icon right dark>arrow_downward</v-icon>
        </v-btn> -->
                </v-toolbar>
            </template>
            <template v-slot:[`item.action`]="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">
                    mdi-pencil
                </v-icon>
                <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
            </template>
            <template v-slot:no-data>
                <v-alert border="right" colored-border type="error" elevation="2">
                    {{ $t("norecordsfound") }}
                </v-alert>
            </template>
        </v-data-table>
    </v-card>
</div>
<div v-else-if="user != null || currentuser != null">
    <v-alert outlined type="warning" prominent border="left">
        {{ $t("accessdenied") }}
    </v-alert>
</div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import i18n from "@/plugins/i18n";
import requestsMixin from "@/mixins/requests"
export default {
    mixins: [requestsMixin],
    data() {
        return {
            search: "",
            headers: [{
                    text: "Plant",
                    align: "start",
                    value: "plant",
                },
                { text: "Company", value: "value" },
                { text: "Other Info", value: "otherInfo" },
                { text: "Updated By", value: "updatedBy" },
                { text: "Updated On", value: "updatedOn" },
                { text: "Actions", value: "action", sortable: false },
            ],
            allcompanies: [],
            companies: [],
            allplants: [],
            plants: [],
            dialog: false,
            statusmessages: [],
            isSucess: false,
            editedIndex: -1,
            selecttedplant: 0,
            editedItem: {
                id: 0,
                plant: "",
                value: "",
                otherInfo: "",
                updatedBy: "",
                updatedOn: new Date().toISOString(),
                categoryId: 2
            },
            defaultItem: {
                id: 0,
                plant: "",
                value: "",
                otherInfo: "",
                updatedBy: "",
                updatedOn: new Date().toISOString(),
                categoryId: 2
            },
            date: new Date().toISOString().substr(0, 10),
            dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
            searchUser: null,
            entries: [],
            useraccess: [],
            currentuser: [],
            readonlyPlant: false,
            tableItemsPerPage: [25, 50, 100, -1]
        };
    },
    mounted() {
        this.getCompaniesFromAPI();
    },
    methods: {
        getCompaniesFromAPI() {
            var self = this;
            self.user = self.$store.state.userDetails;
            const link = window.apiurl + "/contractorcompany";
            axios
                .get(link, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.allcompanies = response.data;
                    if (self.user != null) {
                        const link2 =
                            window.apiurl + "/userheadcount/myview/" + self.user.userEmail;
                        axios
                            .get(link2, {
                                withCredentials: true,
                                headers: self.requestHeaders
                            })
                            .then((response) => {
                                self.useraccess = response.data;
                                i18n.locale = self.useraccess[0].language;
                            })
                            .then(() => self.getPlants())
                            .catch((error) => console.log(error));
                    } else {
                        self.getUser();
                    }
                })
                .catch((error) => console.log(error));
        },
        getPlants() {
            var self = this;
            self.companies = [];
            const link3 = window.apiurl + "/plants";
            axios
                .get(link3, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.allplants = response.data;
                    var filterUser = [];
                    filterUser = self.useraccess.filter((x) => x.plant == "Global");
                    if (filterUser != null && filterUser.length > 0) {
                        self.plants = self.allplants.slice();
                        self.companies = self.allcompanies.slice();
                    } else {
                        var filterPlant = [];
                        filterPlant = self.useraccess.filter((x) => x.company == "LYB");
                        if (filterPlant != null && filterPlant.length > 0) {
                            var index = 0;
                            for (index = 0; filterPlant.length > index; index++) {
                                var plant = self.allplants.filter(
                                    (x) => x.plant == filterPlant[index].plant
                                );
                                self.plants.push(plant[0]);
                                var plantCompanies = self.allcompanies.filter(
                                    (x) => x.plant == filterPlant[index].plant
                                );
                                var index1 = 0;
                                for (index1 = 0; plantCompanies.length > index1; index1++) {
                                    self.companies.push(plantCompanies[index1]);
                                }
                            }
                        }
                    }
                })
                .catch((error) => console.log(error));
        },
        getUser() {
            var self = this;
            axios
                .get(window.apiurl + "/usercontext", {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.currentuser = response.data;
                    const link4 =
                        window.apiurl +
                        "/userheadcount/myview/" +
                        self.currentuser.userEmail;
                    axios
                        .get(link4, {
                            withCredentials: true,
                            headers: self.requestHeaders
                        })
                        .then((response1) => {
                            self.useraccess = response1.data;
                        })
                        .then(() => self.getPlants())
                        .catch((error) => console.log(error));
                })
                .catch((error) => console.log(error));
        },
        close() {
            this.readonlyPlant = false;
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        editItem(item) {
            this.editedIndex = this.companies.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.selecttedplant = this.plants.find(
                (x) => x.plant == this.editedItem.plant
            ).id;
            this.readonlyPlant = true;
            this.dialog = true;
        },
        deleteItem(item) {
            const index = this.companies.indexOf(item);
            if (confirm("Are you sure you want to delete this item?")) {
                var self = this;
                const link = window.apiurl + "/contractorcompany/delete/" + item.id;
                axios
                    .delete(link, { withCredentials: true, headers: self.requestHeaders })
                    .then(function (response) {
                        if (response.data.isSucess) {
                            self.companies.splice(index, 1);
                            alert(response.data.messages[0].message);
                        } else {
                            var index1 = 0;
                            for (
                                index1 = 0; index1 < response.data.messages.length; index1++
                            ) {
                                self.statusmessages.push(response.data.messages[index1]);
                            }
                        }
                    })
                    .catch(function (err) {
                        console.log(err);
                    });
            }
        },
        save() {
            var self = this;
            this.editedItem.plant = this.plants.find(
                (x) => x.id == this.selecttedplant
            ).plant;
            this.editedItem.updatedBy = this.user.userEmail;
            var object = null;

            if (self.editedIndex > -1) {
                const link = window.apiurl + "/contractorcompany/update";
                axios
                    .put(link, this.editedItem, {
                        withCredentials: true,
                        headers: self.requestHeaders
                    })
                    .then((response) => {
                        if (response.data.isSucess) {
                            alert(response.data.messages[0].message);
                            Object.assign(self.companies[self.editedIndex], self.editedItem);
                        } else {
                            var index = 0;
                            for (index = 0; index < response.data.messages.length; index++) {
                                self.statusmessages.push(response.data.messages[index]);
                            }
                        }
                        self.close();
                    })
                    .catch((error) => console.log(error));
            } else {
                if (
                    this.companies.find(
                        (x) =>
                        x.plant == this.editedItem.plant &&
                        x.value == this.editedItem.value
                    ) != null
                )
                    object = this.companies.find(
                        (x) =>
                        x.plant == this.editedItem.plant &&
                        x.value == this.editedItem.value
                    );
                if (object == null) {
                    const link = window.apiurl + "/contractorcompany/create";
                    axios
                        .post(link, this.editedItem, {
                            withCredentials: true,
                            headers: self.requestHeaders
                        })
                        .then(function (response) {
                            if (response.data.isSucess) {
                                const newCompany = {
                                    id: 0,
                                    plant: "",
                                    value: "",
                                    otherInfo: "",
                                    updatedBy: "",
                                    updatedOn: new Date(),
                                    categoryId: 1
                                };
                                newCompany.id = response.data.contractorCompanies.id;
                                newCompany.plant = response.data.contractorCompanies.plant;
                                newCompany.value = response.data.contractorCompanies.value;
                                newCompany.otherInfo =
                                    response.data.contractorCompanies.otherInfo;
                                newCompany.updatedBy =
                                    response.data.contractorCompanies.updatedBy;
                                newCompany.updatedOn =
                                    response.data.contractorCompanies.updatedOn;
                                newCompany.categoryId =
                                    response.data.contractorCompanies.categoryId;
                                self.companies.push(newCompany);
                                alert(response.data.messages[0].message);
                                self.close();
                            } else {
                                var index = 0;
                                for (
                                    index = 0; index < response.data.messages.length; index++
                                ) {
                                    self.statusmessages.push(response.data.messages[index]);
                                }
                            }
                        })
                        .catch(function (err) {
                            console.log(err);
                        });
                    this.close();
                } else {
                    alert("Company already exists for plant");
                }
            }
        },
        changePlant(selecetedObj) {
            if (selecetedObj === parseInt(selecetedObj)) {}
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${month}/${day}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;

            const [month, day, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
        exportexcel() {
            //this.download = true
            this.JSONToCSVConvertor(this.users, "ContractorCompanies - Report", true);
        },
        JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
            //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
            var arrData =
                typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;

            var CSV = "";
            //Set Report title in first row or line

            CSV += ReportTitle + "\r\n\n";

            //This condition will generate the Label/Header
            if (ShowLabel) {
                var row = "";

                //This loop will extract the label from 1st index of on array
                for (var index in arrData[0]) {
                    //Now convert each value to string and comma-seprated
                    row += index + ",";
                }

                row = row.slice(0, -1);

                //append Label row with line break
                CSV += row + "\r\n";
            }

            //1st loop is to extract each row
            for (var i = 0; i < arrData.length; i++) {
                var row = "";

                //2nd loop will extract each column and convert it in string comma-seprated
                for (var index in arrData[i]) {
                    row += '"' + arrData[i][index] + '",';
                }

                row.slice(0, row.length - 1);

                //add a line break after each row
                CSV += row + "\r\n";
            }

            if (CSV == "") {
                alert("Invalid data");
                return;
            }

            var filename = "ContractorCompanies.csv";
            var blob = new Blob([CSV], { type: "text/csv;charset=utf-8;" });
            if (navigator.msSaveBlob) {
                // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) {
                    // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = "hidden";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        },
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ?
                this.$t("newcompany") :
                this.$t("editcompany");
        },
        computedDateFormatted() {
            return this.formatDate(this.date);
        },
        user() {
            return this.$store.state.userDetails;
        },
        hasAdminAccess() {
            var adminaccess = false;
            var filterUser = [];
            filterUser = this.useraccess.filter(
                (x) => x.plant == "Global" || x.company == "LYB"
            );
            if (filterUser != null && filterUser.length > 0) {
                adminaccess = true;
            }
            return adminaccess;
        },
        isLoggedInUserActive() {
            var isuseractive = false;
            if (this.useraccess.length > 0) {
                this.useraccess.forEach(function (elem, index) {
                    if (elem.isActive == "Y") {
                        isuseractive = true;
                    }
                });
            }
            return isuseractive;
        },
    },
    watch: {
        dialog(val) {
            val || this.close();
        },
        date(val) {
            this.dateFormatted = this.formatDate(this.date);
        },
    },
};
</script>



// WEBPACK FOOTER //
// ./src/components/ContractorCompany.vue